import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { TRANSLATIONS } from '../../languages';

export class InlineTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return of((TRANSLATIONS as any)[lang] ?? TRANSLATIONS['pt-BR']);
    }
}
